function About() {
  return <div>
            <h1 className="text-xl mb-4">Github Finder</h1>
            

        </div>;
}

export default About;
